__turbopack_context__.v({
  "show_grid_card": "ShowGridCard-module-scss-module__4_kcmG__show_grid_card",
  "show_grid_card__description": "ShowGridCard-module-scss-module__4_kcmG__show_grid_card__description",
  "show_grid_card__genre": "ShowGridCard-module-scss-module__4_kcmG__show_grid_card__genre",
  "show_grid_card__logo": "ShowGridCard-module-scss-module__4_kcmG__show_grid_card__logo",
});
